"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _InformationChange = require("@/api/member/InformationChange");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InformationChange',
  props: {
    logType: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      regionalInformation: false,
      userOptionData: []
    };
  },
  methods: {
    open: function open(id) {
      this.regionalInformation = true;
      this.queryMemberUpdateLogsApi(id);
      console.log(this.logType);
    },
    regionClose: function regionClose() {
      this.regionalInformation = false;
    },
    queryMemberUpdateLogsApi: function () {
      var _queryMemberUpdateLogsApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(memberId) {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                memberId: memberId
              };
              _context.n = 1;
              return (0, _InformationChange.queryMemberUpdateLogsApi)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                this.userOptionData = res.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function queryMemberUpdateLogsApi(_x) {
        return _queryMemberUpdateLogsApi2.apply(this, arguments);
      }
      return queryMemberUpdateLogsApi;
    }()
  }
};